

const App_Path='';


export const rout_paths = {
    home : `${App_Path}/`,
    moviesCategory : `${App_Path}/movies`,
    uncertain: `${App_Path}/*`,
    MovieDetails: `${App_Path}/movie-details`,
    Liked: `${App_Path}/Liked`,
}